import { z } from 'zod'
import { BacktestSimMode } from '../../enums/backtest-sim-mode.enum'
import { daySettingsSchema } from './backtest-config.schema'

// the reusable part of a backtest config — strategy settings only, excluding
// instruments and the date range (both run-specific)
export const backtestPresetSettingsSchema = z.object({
  defaults: daySettingsSchema,
  simMode: z.nativeEnum(BacktestSimMode),
  bridgeTicksPerBar: z.number().int().min(2).max(200),
})

export type BacktestPresetSettingsDto = z.infer<typeof backtestPresetSettingsSchema>

export const backtestPresetSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(60),
  createdAt: z.coerce.date(),
  settings: backtestPresetSettingsSchema,
})

export type BacktestPresetDto = z.infer<typeof backtestPresetSchema>

export const createBacktestPresetSchema = z.object({
  name: z.string().min(1).max(60),
  settings: backtestPresetSettingsSchema,
})

export type CreateBacktestPresetDto = z.infer<typeof createBacktestPresetSchema>
